import React, { useState } from 'react';
import Select from '../ui/Select';
import Button from '../ui/Button';


const GlobalControlsBar = ({ onFiltersChange }) => {
  const [dateRange, setDateRange] = useState('7d');
  const [currency, setCurrency] = useState('usd');
  const [isRealTime, setIsRealTime] = useState(true);

  const dateRangeOptions = [
    { value: '1h', label: 'Last Hour' },
    { value: '24h', label: 'Last 24 Hours' },
    { value: '7d', label: 'Last 7 Days' },
    { value: '30d', label: 'Last 30 Days' },
    { value: '90d', label: 'Last 90 Days' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const currencyOptions = [
    { value: 'usd', label: 'USD ($)' },
    { value: 'eur', label: 'EUR (€)' },
    { value: 'gbp', label: 'GBP (£)' },
    { value: 'btc', label: 'BTC (₿)' },
    { value: 'eth', label: 'ETH (Ξ)' }
  ];

  const handleDateRangeChange = (value) => {
    setDateRange(value);
    if (onFiltersChange) {
      onFiltersChange({ dateRange: value, currency, isRealTime });
    }
  };

  const handleCurrencyChange = (value) => {
    setCurrency(value);
    if (onFiltersChange) {
      onFiltersChange({ dateRange, currency: value, isRealTime });
    }
  };

  const handleRealTimeToggle = () => {
    const newValue = !isRealTime;
    setIsRealTime(newValue);
    if (onFiltersChange) {
      onFiltersChange({ dateRange, currency, isRealTime: newValue });
    }
  };

  const handleRefresh = () => {
    if (onFiltersChange) {
      onFiltersChange({ dateRange, currency, isRealTime, refresh: true });
    }
  };

  const handleExport = () => {
    console.log('Exporting data with filters:', { dateRange, currency, isRealTime });
  };

  return (
    <div className="controls-bar">
      <div className="controls-content">
        <div className="control-group">
          <span className="control-label">Time Range</span>
          <Select
            options={dateRangeOptions}
            value={dateRange}
            onChange={handleDateRangeChange}
            className="w-40"
          />
        </div>

        <div className="control-group">
          <span className="control-label">Currency</span>
          <Select
            options={currencyOptions}
            value={currency}
            onChange={handleCurrencyChange}
            className="w-32"
          />
        </div>

        <div className="control-group">
          <Button
            variant={isRealTime ? 'default' : 'outline'}
            size="sm"
            onClick={handleRealTimeToggle}
            iconName={isRealTime ? 'Radio' : 'Pause'}
            iconPosition="left"
          >
            {isRealTime ? 'Live' : 'Paused'}
          </Button>
        </div>

        <div className="control-group ml-auto">
          <Button
            variant="ghost"
            size="sm"
            onClick={handleRefresh}
            iconName="RefreshCw"
            iconPosition="left"
          >
            Refresh
          </Button>

          <Button
            variant="outline"
            size="sm"
            onClick={handleExport}
            iconName="Download"
            iconPosition="left"
          >
            Export
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GlobalControlsBar;